import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=6da2765c&scoped=true&lang=pug&"
import script from "./Work.vue?vue&type=script&lang=ts&"
export * from "./Work.vue?vue&type=script&lang=ts&"
import style0 from "./Work.vue?vue&type=style&index=0&id=6da2765c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2765c",
  null
  
)

export default component.exports